import React from 'react';
import { StatusBadge } from '../status/StatusBadge';
import clsx from 'clsx';

interface Props {
	statusName?: string;
	title: string;
	additionalClasses?: string;
}

export const OrderStatus = (props: Props): React.ReactElement => {
	const { statusName, title, additionalClasses } = props;
	return (
		<>
			{
				statusName && (
					<div className="d-flex align-items-center justify-content-between me-5">
						<div className="d-flex align-items-center justify-content-center">
							<span className="fs-5 text-muted">
								{title}
							</span>
						</div>
						<div className="d-flex align-items-center justify-content-center">
							<span
								className="h-30px border-gray-500 border-2 border-start mx-4"
								style={{ borderColor: '#8E8E93' }}
							/>
						</div>
						<StatusBadge
							status={statusName}
							additionalClasses={clsx('fs-5 bg-transparent p-0', additionalClasses)}
						/>
					</div>
				)
			}
		</>
	);
};


